import { useMutation } from "react-query";
import { addEmployeeReportsTo } from "../../../../../actions/Utilities/EmployeeReportsTo";
import { toast } from "components/toastNotification";
import { IEmployeeReportsTo } from "../types";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  addStateEmployeeReportsTo,
  employeeReportsToReFetching,
} from "../atoms/atoms";

const useAddEmployeeReportsTo = () => {
  const setIsAddState = useSetRecoilState(addStateEmployeeReportsTo);
  const [isReFetching, setIsReFetching] = useRecoilState(
    employeeReportsToReFetching
  );

  const { mutate } = useMutation(
    (NewData: IEmployeeReportsTo) => addEmployeeReportsTo(NewData),
    {
      onSuccess: (res: any) => {
        if (typeof res == "object") {
          toast.fire("Adding Employee Reports To failed", res.Message, "error");
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "Employee Reports To Added Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Employee Reports To Added Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Adding Employee Reports To failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "The data already exists!":
              toast.fire(
                "Adding Employee Reports To failed",
                `Duplication Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire("Adding Employee Reports To failed", res, "error");
          }
        }

        // Redirect to View
        setIsAddState(false);

        // ReFetch Data
        setIsReFetching(isReFetching ? false : true);
      },

      onError: (error: any) => {
        toast.fire("Add Employee Reports To failed", `Error: ${error}`, "error");
      },
    }
  );

  return mutate;
};
export default useAddEmployeeReportsTo;
